/* 🤖 this file was generated by svg-to-ts */
export const matIconFirstPage: {
  name: 'first-page';
  data: string;
} = {
  name: 'first-page',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z"/></svg>`
};
